import React, { useState, ChangeEvent, useEffect } from "react";
import { DisplayConfigDTO } from "../../interfaces/DistplayConfigDTO";
import { Button, Form } from "react-bootstrap";
import { useDisplays } from "../../services/displayservices/DisplayProvider";

const DisplaySettings = () => {
  const {display,setDisplays,getDisplays} = useDisplays();

  const [config, setConfig] = useState< DisplayConfigDTO>(getDisplays() !== null ? getDisplays()! : {
    IPAdress: "",
    RaceID: null,
    Port: 0,
    Width: 1920,
    Height: 1080,
    MarginLeft: 0,
    MarginTop: 0,
    LineHeight: 10,
    ResultLines: 10,
    ScrollLines: 5,
    ShowScroll: true,
    ShowResultLines: true,
    ShowResultClassName: true,
    ShowScrollClassName: true,
    RankWidth: null,
    StartnoWidth: null,
    NameWidth: null,
    ShortNameWidth: null,
    TeamWidth: null,
    TimeWidth: null,
    NationWidth: null,
    DiffWidth: null,
    RuntimeWidth: null,
    FontSize: null,
    FontSizeHeader: null,
    FontSizeAdver: null,
    AdverShowInSeconds: null,
    AdverShowTimeAfterLastFinishInSeconds: null,
    AdverText: "",
    ScrollLinesColor: "#FFFFFF",
    ResultLinesColor: "#FFFFFF",
    ResultBorderColor: "#000000",
    ResultBorderHeight: 2,
    TextColor: "#000000",
    Backgroundcolor: "#000000",
    TimeNow: new Date().toISOString(),
  });
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    setConfig({ ...config, [name]: newValue });
  };
  useEffect(() => {
    setDisplays(config)
  },[config])
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Submit the form with the config state
    console.log(config);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formWidth">
      <Form.Label>Width:</Form.Label>
      <Form.Control
        type="number"
        name="Width"
        value={config.Width || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formHeight">
      <Form.Label>Height:</Form.Label>
      <Form.Control
        type="number"
        name="Height"
        value={config.Height || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formMarginLeft">
      <Form.Label>Margin left:</Form.Label>
      <Form.Control
        type="number"
        name="MarginLeft"
        value={config.MarginLeft || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formMarginTop">
      <Form.Label>Margin top:</Form.Label>
      <Form.Control
        type="number"
        name="MarginTop"
        value={config.MarginTop || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formLineHeight">
      <Form.Label>LineHeight:</Form.Label>
      <Form.Control
        type="number"
        name="LineHeight"
        value={config.LineHeight || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formResultLines">
      <Form.Label>Result Lines:</Form.Label>
      <Form.Control
        type="number"
        name="ResultLines"
        value={config.ResultLines || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formScrollLines">
      <Form.Label>Scroll lines:</Form.Label>
      <Form.Control
        type="number"
        name="ScrollLines"
        value={config.ScrollLines || ""}
        onChange={handleChange}
        
      />
    </Form.Group>

    <Form.Group controlId="formShowScroll">
      <Form.Check
        type="checkbox"
        label="Show Scroll"
        name="ShowScroll"
        checked={config.ShowScroll}
        onChange={handleChange}
        disabled
      />
    </Form.Group>

    <Form.Group controlId="formShowResultLines">
      <Form.Check
        type="checkbox"
        label="Show Result Lines"
        name="ShowResultLines"
        checked={config.ShowResultLines}
        onChange={handleChange}
        disabled
      />
    </Form.Group>
    <Form.Group controlId="formShowResultClassName">
      <Form.Check
        type="checkbox"
        label="Show Result Class Name"
        name="ShowResultClassName"
        checked={config.ShowResultClassName}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formShowScrollClassName">
      <Form.Check
        type="checkbox"
        label="Show Scroll Classname"
        name="ShowScrollClassName"
        checked={config.ShowScrollClassName}
        onChange={handleChange}
        disabled
      />
    </Form.Group>

    <Form.Group controlId="formGridRankWidth">
      <Form.Label>Rank Width</Form.Label>
      <Form.Control
        type="number"
        name="RankWidth"
        value={config.RankWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridStartnoWidth">
      <Form.Label>Startno Width</Form.Label>
      <Form.Control
        type="number"
        name="StartnoWidth"
        value={config.StartnoWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridNameWidth">
      <Form.Label>Name Width</Form.Label>
      <Form.Control
        type="number"
        name="NameWidth"
        value={config.NameWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridShortNameWidth">
      <Form.Label>Short Name Width</Form.Label>
      <Form.Control
        type="number"
        name="ShortNameWidth"
        value={config.ShortNameWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridTeamWidth">
      <Form.Label>Team Width</Form.Label>
      <Form.Control
        type="number"
        name="TeamWidth"
        value={config.TeamWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formNationWidth">
      <Form.Label>Nation Width</Form.Label>
      <Form.Control
        type="number"
        name="NationWidth"
        value={config.NationWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridTimeWidth">
      <Form.Label>Time Width (rank 1 have runtime rest have difftime)</Form.Label>
      <Form.Control
        type="number"
        name="TimeWidth"
        value={config.TimeWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridDiffWidth">
      <Form.Label>Diff Width</Form.Label>
      <Form.Control
        type="number"
        name="DiffWidth"
        value={config.DiffWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridRuntimeWidth">
      <Form.Label>Runtime Width</Form.Label>
      <Form.Control
        type="number"
        name="RuntimeWidth"
        value={config.RuntimeWidth || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridFontSize">
      <Form.Label>Font Size</Form.Label>
      <Form.Control
        type="number"
        name="FontSize"
        value={config.FontSize || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridFontSizeHeader">
      <Form.Label>Font Size Header results</Form.Label>
      <Form.Control
        type="number"
        name="FontSizeHeader"
        value={config.FontSizeHeader || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridFontSizeAdver">
      <Form.Label>Font Size Advertising</Form.Label>
      <Form.Control
        type="number"
        name="FontSizeAdver"
        value={config.FontSizeAdver || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridAdverShowInSeconds">
      <Form.Label>Adver Show In Seconds</Form.Label>
      <Form.Control
        type="number"
        name="AdverShowInSeconds"
        value={config.AdverShowInSeconds || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formGridAdverShowTimeAfterLastFinishInSeconds">
      <Form.Label>Adver Show Time After Last Finish In Seconds</Form.Label>
      <Form.Control
        type="number"
        name="AdverShowTimeAfterLastFinishInSeconds"
        value={config.AdverShowTimeAfterLastFinishInSeconds || ""}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formAdverText">
      <Form.Label>Text to be shown in box, HTML are okay</Form.Label>
      <Form.Control
        type="textarea"
        as="textarea" 
        rows={3} 
        name="AdverText"
        value={config.AdverText || ""}
        onChange={handleChange}
      />
    </Form.Group>


    <Form.Group controlId="formTextColor">
      <Form.Label>Text Color:</Form.Label>
      <Form.Control
        type="color"
        name="TextColor"
        value={config.TextColor}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formScrollLinesColor">
      <Form.Label>Scroll Lines Color:</Form.Label>
      <Form.Control
        type="color"
        name="ScrollLinesColor"
        value={config.ScrollLinesColor}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formResultLinesColor">
      <Form.Label>Result Lines Color:</Form.Label>
      <Form.Control
        type="color"
        name="ResultLinesColor"
        value={config.ResultLinesColor}
        onChange={handleChange}
      />
    </Form.Group>

    <Form.Group controlId="formBackgroundColor">
      <Form.Label>Background Color:</Form.Label>
      <Form.Control
        type="color"
        name="Backgroundcolor"
        value={config.Backgroundcolor}
        onChange={handleChange}
      />
    </Form.Group>

    
    <Form.Group controlId="formResultBorderHeight">
      <Form.Label>Result border height:</Form.Label>
      <Form.Control
        type="number"
        name="ResultBorderHeight"
        value={config.ResultBorderHeight || ""}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formResultBorderColor">
      <Form.Label>Result border Color:</Form.Label>
      <Form.Control
        type="color"
        name="ResultBorderColor"
        value={config.ResultBorderColor}
        onChange={handleChange}
      />
    </Form.Group>

  </Form>

  );
};

export default DisplaySettings;
